(function (window) {
  const targetHostnames = ['onlinestore2.wine-at.jp', '-old.onlinestore.wine-at.jp'];
  const targetPaths = [
    '/',
    '/cart',
    '/products/[0-9A-Z]+',
    '/account/login',
    '/search',
    '/karte',
    '/reviews',
    '/locations/ebisu',
    '/favorite',
    '/pages/member_id',
    '/mypage',
    '/mypage/orders',
    '/pages/faq',
    '/pages/guide',
    '/pages/legal-notice',
    '/policies/privacy-policy',
    '/policies/terms-of-service',
    '/logout',
  ];
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;
  const currentLocation = window.location.toString();
  for (let i = 0; i < targetHostnames.length; i += 1) {
    if (!new RegExp(targetHostnames[i]).test(hostname)) continue;
    for (let j = 0; j < targetPaths.length; j += 1) {
      if (!new RegExp('^' + targetPaths[j] + '$').test(pathname)) continue;
      const currentUrl = new URL(currentLocation);
      currentUrl.hostname = hostname.replace(/-old/, '').replace(/2/, '');
      window.location.replace(currentUrl.href);
    }
  }
})(window);
